define('@brightspark/sparkling-ajax-js', ["@brightspark/sparkling-observable-js"], function(observable){

	var _ajaxGlobal = {};

	var _knownContentType = {
		json: "application/json",
		urlEncoded: "application/x-www-form-urlencoded",
		multiPartFormData: "multipart/form-data"
	};

	var _jsonContentTypeRegExp = new RegExp("^application/json(.*)");

	var _dataType = {
		json: "json",
		text: "text",
		auto: "auto"
	};

	var _events = {
		done: "done",
		fail: "fail",
		always: "always",
		progress: "progress",
		abort: "abort",
		error: "error"
	};

	var _httpMethodsWithBody = {
		"POST": true,
		"PUT": true,
		"CONNECT": true,
		"PATCH": true
	};

	_ajaxGlobal.defaults = {
		method: "POST",
		contentType: _knownContentType.urlEncoded,
		headers: { "X-Requested-With": "XMLHttpRequest" },
		publishGlobals: true,
		dataType: "text"
	};

	_ajaxGlobal.overrideDefaults = function (newDefaults) {
		for (var i in newDefaults) {
			if (newDefaults.hasOwnProperty(i) && _ajaxGlobal.defaults.hasOwnProperty(i)) {
				_ajaxGlobal.defaults[i] = newDefaults[i];
			}
		}
	};

	observable.mixin(_ajaxGlobal);

	_ajaxGlobal.start = _ajaxGlobal.createPublishSubscribe("ajaxStart");
	_ajaxGlobal.complete = _ajaxGlobal.createPublishSubscribe("ajaxComplete");
	_ajaxGlobal.error = _ajaxGlobal.createPublishSubscribe("error");

    /**
    * Create new ajax request
    * @param {string} url
    * @param {object} settings
    * @returns {ajax.AjaxRequest}
	*/
	
	var ajax = function (url, settings) {
		return new ajax.AjaxRequest(url, settings || {});
	};

	ajax.AjaxRequest = function (url, settings) {
		var _this = this;

		observable.mixin(_this);

		var _complete = false;
		var _xhr;
		var _result;
		var _propagate = {};
		var _publishGlobalEvents = typeof settings.publishGlobals === "boolean"
			? settings.publishGlobals
			: _ajaxGlobal.defaults.publishGlobals;

		var _stopped = false;

		Object.defineProperties(this, {
			settings: {
				get: function () {
					return settings;
				}
			}
		});

        /**
         * Helper function to handle promise callbacks
         * @param {function} cb
         * @param {string} eventName
         * @returns {ajax.AjaxRequest}
         */
		function handleCallbackEvent(cb, eventName) {
			if (_propagate[eventName] === false) {
				return _this;
			}

			if (_complete) {

				var done = _xhr.status >= 200 && _xhr.status < 300 || status === 304;

				if (eventName === _events.done && done) {
					_propagate[_events.done] = cb(_result, _xhr);
				}
				else if (eventName === _events.fail && !done) {
					_propagate[_events.fail] = cb(_result, _xhr);
				}
				else if (eventName === _events.always) {
					_propagate[_events.always] = cb(_result, _xhr);
				}
				else if (eventName === _events.progress) {
					_propagate[_events.progress] = cb({ loaded: 1, total: 1 }, _result, _xhr);
				}
			} else {
				_this.subscribe(eventName, cb);
			}

			return _this;
		}

        /**
         * Aborts the request
         */
		this.abort = function () {

			if (!_complete) {
				_xhr.abort();
				_this.publish(_events.abort, _xhr);
			}
			else {
				_this.publish(_events.abort);
			}

			_this.stop();
		};

        /**
         * Stop the request processing
         */
		this.stop = function () {
			_stopped = true;
		};

        /**
         * Register success handler
         * @param {function} cb
         * @returns {ajax.AjaxRequest}
         */
		this.done = function (cb) {
			return handleCallbackEvent(cb, _events.done);
		};

        /**
         * Register error handler
         * @param {function} cb
         * @returns {ajax.AjaxRequest}
         */
		this.fail = function (cb) {
			return handleCallbackEvent(cb, _events.fail);
		};

        /**
         * Register progress changed handler
         * @param {function} cb
         * @returns {ajax.AjaxRequest}
         */
		this.progress = function (cb) {
			return handleCallbackEvent(cb, _events.progress);
		};

        /**
         * Register ajax complete handler
         * @param {function} cb
         * @returns {ajax.AjaxRequest}
         */
		this.always = function (cb) {
			return handleCallbackEvent(cb, _events.always);
		};

        /**
         * Register handler for any type of error during ajax request.
         * @param {function} cb The handler function.
         */
		this.error = function (cb) {
			_this.subscribe(_events.error, cb);
		};

		function handleXhrResult() {
			if (_xhr.status >= 200 && _xhr.status < 300 || status === 304) {
				_propagate[_events.done] = _this.publish(_events.done, _result, _xhr);
			} else {
				_propagate[_events.fail] = _this.publish(_events.fail, _result, _xhr);
			}

			_propagate[_events.always] = _this.publish(_events.always, _result, _xhr);
		}

		function processResponseText(dataType) {

			var responseText = _xhr.responseText;
			if (dataType === _dataType.auto) {
				var contentType = (_xhr.getResponseHeader('content-type') || "").toLowerCase();
				if (_jsonContentTypeRegExp.test(contentType)) {
					dataType = _dataType.json;
				}
				else {
					dataType = _dataType.text;
				}
			}

			if (dataType === _dataType.json) {
				try {
					return responseText ? JSON.parse(responseText) : {};
				} catch (e) {
					_this.publish(_events.error, e, _xhr);
					publishGlobalEvent("error", e, _xhr);

					return {};
				}
			} else {
				return responseText;
			}
		}

		function publishGlobalEvent(eventName, p1, p2, p3) {
			if (_publishGlobalEvents) {
				return _ajaxGlobal[eventName].call(_this, p1, p2, p3);
			}
		}

		// prepare request info

		var isMultipartFormData = settings.data instanceof FormData;

		var method = settings.method || _ajaxGlobal.defaults.method;
		var contentType = settings.contentType || _ajaxGlobal.defaults.contentType;
		var dataType = settings.dataType || _ajaxGlobal.defaults.dataType;
		var headers = clone(_ajaxGlobal.defaults.headers);

		var methodUpper = method.toUpperCase();
		var hasBody = _httpMethodsWithBody[methodUpper] === true;
		var isContentTypeRequired = !isMultipartFormData && hasBody;
		if (isContentTypeRequired) {
			headers["Content-Type"] = contentType;
		}

		var data = isMultipartFormData
			? settings.data
			: stringifyRequestData(contentType, settings.data);

		// do ajax call

		_xhr = new XMLHttpRequest();
		_xhr.open(method, encodeURI(url));

		for (var i in headers) {
			if (headers.hasOwnProperty(i)) {
				_xhr.setRequestHeader(i, headers[i]);
			}
		}

		if (_xhr.upload) {
			_xhr.upload.addEventListener(_events.progress, function (e) {
				_this.publish(_events.progress, e);
			}, false);
		}

		_xhr.onreadystatechange = function () {

			if (_xhr.readyState === XMLHttpRequest.DONE) {
				_complete = true;
				_result = processResponseText(dataType);
				var stopPropagation = publishGlobalEvent("complete", _result, _xhr) === false;
				_stopped = _stopped || stopPropagation;
				if (_stopped) {
					return;
				}

				handleXhrResult();
			}
		};

		publishGlobalEvent("start", data, _xhr);

		_xhr.send(data);
	};

	function stringifyRequestData(contentType, data) {

		switch (contentType.toLowerCase()) {

			case _knownContentType.json:
				return JSON.stringify(data);

			case _knownContentType.urlEncoded:
				if (typeof data === "string") {
					return data;
				}

				return serializeDataObject(data);

			default:
				return data;
		}
	}

	function serializeDataObject(data) {

		var kvps = [];
		if (data) {
			if (Array.isArray(data)) {
				for (var i = 0; i < data.length; i++) {
					kvps.push(encodeURIComponent(data[i].name) + "=" + encodeValue(data[i].value));
				}
			} else {
				for (var key in data) {
					if (data.hasOwnProperty(key)) {
						kvps.push(encodeURIComponent(key) + "=" + encodeValue(data[key]));
					}
				}
			}
		}

		return kvps.join("&");
	}

	function encodeValue(value) {
		if (typeof value === "undefined" || value === null) {
			return '';
		}
		
		return encodeURIComponent(value);
	}

	function clone(obj) {
		var dest = {};

		for (var i in obj) {
			var el = obj[i];
			if (typeof (el) === "object") {
				dest[i] = clone(el);
			} else {
				dest[i] = el;
			}
		}

		return dest;
	}

	ajax.start = _ajaxGlobal.start;
	ajax.complete = _ajaxGlobal.complete;
	ajax.error = _ajaxGlobal.error;
	ajax.overrideDefaults = _ajaxGlobal.overrideDefaults;
	ajax.subscribe = _ajaxGlobal.subscribe;
	ajax.unsubscribe = _ajaxGlobal.unsubscribe;

	return ajax;

});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@brightspark/sparkling-ajax-js/sparkling-ajax.js
// module id = 14
// module chunks = 10